import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WebSocketState {
  connected: boolean;
  channels: string[];
  error: string | null;
  reconnectAttempts: number;
}

const initialState: WebSocketState = {
  connected: false,
  channels: [],
  error: null,
  reconnectAttempts: 0,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    connected: (state) => {
      state.connected = true;
      state.error = null;
      state.reconnectAttempts = 0;
    },
    disconnected: (state) => {
      state.connected = false;
    },
    subscribe: (state, action: PayloadAction<string>) => {
      if (!state.channels.includes(action.payload)) {
        state.channels.push(action.payload);
      }
    },
    unsubscribe: (state, action: PayloadAction<string>) => {
      state.channels = state.channels.filter(ch => ch !== action.payload);
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    incrementReconnectAttempts: (state) => {
      state.reconnectAttempts += 1;
    },
    resetReconnectAttempts: (state) => {
      state.reconnectAttempts = 0;
    },
  },
});

export const {
  connected,
  disconnected,
  subscribe,
  unsubscribe,
  setError,
  incrementReconnectAttempts,
  resetReconnectAttempts,
} = websocketSlice.actions;
export default websocketSlice.reducer;

